import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-emerald-600 group-[.toaster]:text-white group-[.toaster]:border-emerald-700 group-[.toaster]:shadow-xl group-[.toaster]:rounded-xl group-[.toaster]:border",
          description: "group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:bg-white group-[.toast]:text-emerald-700 group-[.toast]:rounded-lg group-[.toast]:font-semibold",
          cancelButton:
            "group-[.toast]:bg-white/20 group-[.toast]:text-white group-[.toast]:rounded-lg",
          success:
            "group-[.toaster]:bg-emerald-600 group-[.toaster]:border-emerald-700",
          error:
            "group-[.toaster]:bg-red-600 group-[.toaster]:border-red-700",
          warning:
            "group-[.toaster]:bg-amber-500 group-[.toaster]:border-amber-600",
          info:
            "group-[.toaster]:bg-emerald-600 group-[.toaster]:border-emerald-700",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
